import { observable, computed, action } from 'mobx';
import { query, serviceQueries } from '@estee/elc-service-bus';

import Config from '~domain/entities/Config/Config';
import { ICartSidebarServiceConfig } from '~domain/entities/Config/IConfig';
import IConfigRepository from '~repositories/ConfigRepository/IConfigRepository';

export default class ConfigRepository {
    @observable private _config: Config;

    constructor({ entity }: IConfigRepository) {
        this._config = entity;
    }

    @action
    public updateConfigs = async (configs: ICartSidebarServiceConfig) => {
        this._config.updateConfig(configs);
    };

    @action
    public fetchConfigs = async (configs: string[]) => {
        const fetchedConfigs = (await query(
            serviceQueries.GET_CONFIG,
            configs
        )) as ICartSidebarServiceConfig;

        this._config.updateConfig(fetchedConfigs);
    };

    @computed
    public get config(): Config {
        return this._config;
    }
}
